import { CLARK_USER_PREFERENCES_SECTION_FEATURE_FLAG_ID } from "core/clark/user-preferences/preferences";
import { Flag } from "store/slices/featureFlags";

import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Dashboard-side adapter for the builder preferences section flag. The flag id
 * is defined in core so app and dashboard stay aligned without core importing
 * either surface's `Flag` enum.
 */
export const useClarkUserPreferencesEnabled = (): boolean =>
  Boolean(
    useFeatureFlag(CLARK_USER_PREFERENCES_SECTION_FEATURE_FLAG_ID as Flag),
  );
